import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LoginInput} from '../domain/user.type';
import {LocalStorageService} from '../../services/local-storage.service';
import {Router} from '@angular/router';

interface LoginResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})

export class UsersRepository {
  #http = inject(HttpClient);
  #authUrl = `${ environment.apiUrl }`;
  #localStorage = inject(LocalStorageService);
  constructor(private readonly router: Router) {}

  login$(loginInput: LoginInput): Observable<LoginResponse> {
    return this.#http.post<LoginResponse>(`${ this.#authUrl }/login`, loginInput);
  }

  logout$() {
    this.#localStorage.removeItem('token');
    void this.router.navigate(['login']);
  }
}
